module.exports = __webpack_public_path__ + "static/media/S (32).26238f27.jpg";